import React from 'react';
import Header from 'components/common/Header';
import Footer from 'components/common/Footer';
import StudioNavbar from 'components/studio/StudioNavbar';
import { useAuth } from 'context/AuthContext';
import { Link, NavLink, useLocation } from 'react-router-dom';
import Logo from 'assets/brand-logo-compact.svg';
import { Truck } from 'lucide-react';
import BookingShell from './BookingShell';
import ChatWidgetLoader from './ChatWidgetLoader';
import '../../styles/layout/header-improvements.css';
import '../../styles/layout/app-shell.css';
import '../../styles/pages/distribution-planner.css';

export default function Layout({ children, wide = false }) {
  const { currentUser } = useAuth();
  const location = useLocation();
  const next = new URLSearchParams(location.search).get('next') || '';
  const isBooking = location.pathname === '/create-task' ||
    (['/login', '/register'].includes(location.pathname) && next.startsWith('/create-task'));
  const isModerator = currentUser?.role === 'content_moderator';

  if (isBooking) return <BookingShell>{children}</BookingShell>;

  const isOperations = currentUser && (['/koersel','/min-tur'].includes(location.pathname) ||
    (currentUser.role === 'admin' && ['/admin','/admin/depots'].includes(location.pathname)));
  if (isOperations) return <div className="operations-shell"><header className="operations-header"><Link className="operations-brand" to="/dashboard"><img src={Logo} alt="Flytte & Fragttilbud" /></Link>{currentUser.role === 'admin' && <Link to="/admin?tab=dispatch">Disponering</Link>}{currentUser.role === 'carrier' && <NavLink className="nav-link" to={currentUser.distributionDriver?'/min-tur':'/koersel'}><Truck size={17} aria-hidden="true" /> Mine ture</NavLink>}<Link to="/dashboard">Oversigt</Link></header><main className="operations-main">{children}</main></div>;

  if (isModerator) {
    return (
      <div className="app-shell bg-slate-50 text-slate-900" style={{ backgroundColor: '#f8fafc', color: '#0f172a' }}>
        <StudioNavbar />
        <main className="app-main container-app py-6 md:py-10">
          {children}
        </main>
        <footer className="py-6 border-t border-slate-200 bg-white" style={{ backgroundColor: '#ffffff', borderTop: '1px solid #e2e8f0', padding: '24px 0' }}>
          <div className="container-app flex flex-col md:flex-row justify-between items-center text-sm text-slate-500 gap-4" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#64748b' }}>
            <div>
              <strong>DS Platform Studio</strong> — Professionelt indholdsstyringssystem (CMS)
            </div>
            <div>
              © {new Date().getFullYear()} DS-Platform. Alle rettigheder forbeholdes.
            </div>
          </div>
        </footer>
      </div>
    );
  }

  return (
    <div className="app-shell">
      <Header />
      <main className={wide ? 'app-main' : 'app-main container-app py-6 md:py-10'}>
        {children}
      </main>
      <ChatWidgetLoader />
      <Footer />
    </div>
  );
}
